"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createEventSlugInitializer = void 0;

var utils_1 = require("./utils");
/**
 * Returns the initial value of the EventSlug
 */


var createEventSlugInitializer = function createEventSlugInitializer(_a) {
  var urlInterface = _a.urlInterface,
      reactiveMap = _a.reactiveMap;
  return function () {
    var _a, _b; // Pull from URL interface if present. otherwise pull from window


    var pathname = (_a = urlInterface === null || urlInterface === void 0 ? void 0 : urlInterface.location.pathname) !== null && _a !== void 0 ? _a : window === null || window === void 0 ? void 0 : window.location.pathname; // If urlInterface is provided, update the event_slug on url changes

    (_b = urlInterface === null || urlInterface === void 0 ? void 0 : urlInterface.listen) === null || _b === void 0 ? void 0 : _b.call(urlInterface, function (_a) {
      var location = _a.location;
      var eventSlugItem = reactiveMap.item('event_slug');
      var eventSlug = (0, utils_1.getEventSlugFromPath)(location.pathname);
      eventSlugItem.set(eventSlug);
    });
    return (0, utils_1.getEventSlugFromPath)(pathname);
  };
};

exports.createEventSlugInitializer = createEventSlugInitializer;